import type {
  ClientResponse,
  ServerResponse,
} from '@onhandtech/onhand-fe-shared/lib/api/v5/request-filter-set/post-request-filter-set/post-request-filter-set.types'
import { moduleName } from '@onhandtech/onhand-fe-shared/lib/api/v5/request-filter-set/post-request-filter-set/post-request-filter-set.types'
import { handleSuccess } from '@onhandtech/onhand-fe-shared/lib/api/v5/request-filter-set/post-request-filter-set/services/handle-success'
import type { PostRequestFilterSetPayload } from '@onhandtech/onhand-fe-shared/lib/contracts/api/v5/request-filter-set/request-filter-set'
import { createReduxServiceModule } from '@onhandtech/onhand-fe-shared/lib/redux'
import type { RequestArgs } from '@onhandtech/onhand-fe-shared/lib/request'
import { createRequestError } from '@onhandtech/onhand-fe-shared/lib/request'
import type { AxiosError } from 'axios'
import { getConfig } from 'config/configuration'

const args: RequestArgs<ServerResponse, ClientResponse, never, PostRequestFilterSetPayload> = {
  method: 'POST',
  url: getConfig().endpoints.api.v5.requestFilterSet,
  handleSuccess,
  handleFailure: (e: AxiosError) => createRequestError(e, e.code ?? 'POST-REQUEST-FILTER'),
}

const postRequestFilterSetsModule = () =>
  createReduxServiceModule<ServerResponse, ClientResponse, never, PostRequestFilterSetPayload>({
    moduleName,
    args,
  })

export default postRequestFilterSetsModule
